export enum CacheName {
	FrontDisplay = 'front-display',
}
